import { Popper } from "@mui/material"

const CustomPopper = (props) => {
    return (<Popper {...props} disablePortal modifiers={[{ name: "flip", options: { flipVariations: false, fallbackPlacements: [], allowedAutoPlacements: ["bottom"] } }]} popperOptions={{ placement: "bottom" }} />)
}

export default CustomPopper;